export default __webpack_public_path__ + "static/media/isotype.45daa5fd.svg";